import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-the-c01-form-note-panel-gift-card" }
const _hoisted_2 = {
  key: 0,
  class: "p-the-c01-form-note-panel-gift-card__content"
}
const _hoisted_3 = {
  key: 1,
  class: "p-the-c01-form-note-panel-gift-card__content p-the-c01-form-note-panel-gift-card__content--wide"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (
        _ctx.isGiftCardAndNormalItemInCart ||
          _ctx.isWebCouponAndNormalItemInCart ||
          _ctx.isGiftCardAndWebCouponItemInCart ||
          _ctx.isWebCouponAndGiftItemInCart
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " ギフトコードは、他の商品と一緒に申込みできません。 "))
      : _createCommentVNode("", true),
    (
        _ctx.isNormalItemAndGiftCardInCart || _ctx.isBenepoExchangeAndSomethingsInCart
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " こちらの商品は、カートの商品と一緒に申込みすることができません。 カートの商品をお申込みの上、再度カートに入れていただくか、カートの商品を削除してください。 "))
      : _createCommentVNode("", true)
  ]))
}